import { queryAll, touchAllP } from 'lambda-dom'

import { ArticleDataInterface, ArticleSectionDataInterface } from './newsroom-overview.types'

const idLookup = <T extends HTMLElement = HTMLElement>(id: string) => document.getElementById(id) as T

// ------------------------------------------------------------------------------
//      Preview container
// ------------------------------------------------------------------------------

export const previewContainer = idLookup('preview-container')
export const previewContentContainer = previewContainer.querySelector<HTMLElement>('.nap--canvas')!
export const heroContainer = idLookup('newsroom-hero')
export const heroFilterToggle = idLookup<HTMLButtonElement>('newsroom-filter-button')
export const articleListSpacer = idLookup('article-list-spacer')
export const filterContainer = idLookup('newsroom-filters')
export const searchField = idLookup<HTMLInputElement>('newsroom-search-field')
export const searchForm = idLookup<HTMLFormElement>('newsroom-search-form')
export const noResultsSearchForm = idLookup<HTMLFormElement>('newsroom-no-results-search-form')
export const noResultsContainer = idLookup('newsroom-no-results')
export const noResultsHeader = idLookup('newsroom-no-results-header')
export const noResultsSearchField = idLookup<HTMLInputElement>('newsroom-no-results-search-field')

export const articleListContainer = idLookup<HTMLElement>('newsroom-articles-container')

export const anyQuestionsCard = (idLookup('any-questions-template') as HTMLTemplateElement).content.querySelector('.any-questions')
export const eventsCard = (idLookup('events-template') as HTMLElement)
export const filtersCard = (idLookup('filters-template') as HTMLTemplateElement).content.querySelector('.filters-card')

// ------------------------------------------------------------------------------
//      Filter bar
// ------------------------------------------------------------------------------
export const filterBar = idLookup('newsroom-filter-bar')

export const filterBarButtons = {
    showMenuNotFiltered: filterBar.querySelector<HTMLButtonElement>('[data-open-filters][data-filter-off]')!,
    showMenuFiltered: filterBar.querySelector<HTMLButtonElement>('[data-open-filters][data-filter-on]')!,
    closeMenu: filterBar.querySelector<HTMLButtonElement>('[data-close-filters]')!,
    resetProgress: filterBar.querySelector<HTMLButtonElement>('[data-reset-progress]')!,
    clearFilters: filterBar.querySelector<HTMLButtonElement>('[data-clear-filters]')!,
}

// ------------------------------------------------------------------------------
//      Filter labels
// ------------------------------------------------------------------------------

export const filterLabels = queryAll<HTMLElement>('[data-filter-label]')

// ------------------------------------------------------------------------------
//      All article data
// ------------------------------------------------------------------------------
//
//

export const allNewsroomData = (): [ArticleDataInterface[], ArticleSectionDataInterface[]] => {
    let returnArticles: ArticleDataInterface[] = []
    let returnSections: ArticleSectionDataInterface[] = []

    const allArticleDataContainer = document.getElementById('all-articles')

    if (! allArticleDataContainer) return [[], []]

    const articlesString = allArticleDataContainer.dataset.allArticles

    if (! articlesString) return [[], []]

    const parsedData = JSON.parse(articlesString) as {
        [key: string]: ArticleDataInterface | ArticleSectionDataInterface,
    }

    Object.entries(parsedData).forEach((data: [any, ArticleDataInterface | ArticleSectionDataInterface]) => {
        if (data[1].type === 'article') {
            returnArticles.push(data[1])
        }
        if (data[1].type === 'article_section') {
            returnSections.push(data[1])
        }
    })

    allArticleDataContainer.remove()

    return [returnArticles, returnSections]
}
